<template>
  <div class='EnbGift'>
    <div class="cont-btn">
      <add-icon
      text="Adicionar um cupom"
      :active="true"
      :optionsLabel="{ width: '100px', marginTop: '90px', marginRight: '50px' }"
      @click="$router.push('/painel/gift/register')"
      />
      <input-search
      placeholder="Código do cupom"
      action="SearchGiftPainel"
      />
    </div>
    <gift-header/>
    <enb-vazio
    v-if="!Gifts.length && !GlobalLoading"
    text="Nenhum registro encontrado!"
    />
    <div class="cont" @scroll="run">
      <gift-list
      v-for="(data, key) in Gifts"
      :key="key"
      :data="data"
      :chave="key"
      />
      <div class="bottom">
        <vue-spinner v-if="load" size="45"/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import GiftHeader from './header/GiftHeader'
import GiftList from './Itens/GiftList'
import AddIcon from '../Icons/AddIcon'
import InputSearch from '../Search/InputSearch'
import { VueSpinner } from 'vue3-spinners'
import EnbVazio from '../EnbVazio'
export default {
  name: 'EnbGift',
  components: { GiftHeader, GiftList, AddIcon, InputSearch, VueSpinner, EnbVazio },
  data () {
    return {
      scroll: {
        position: 0,
        height: 1
      },
     load: false
    }
  },
  computed: {
    ...mapGetters(['Gifts', 'GlobalLoading'])
  },
  methods: {
    ...mapActions(['GetGift', 'Loading']),
    run (e) {
      this.scroll = {
        position: (e.target.offsetHeight + e.target.scrollTop),
        height: e.target.scrollHeight
      }
      if((this.scroll.height - this.scroll.position) <= 1) {
        //busca
        this.load = true
        setTimeout(() => {
          this.GetGift({
            params: {
              last: this.Gifts[this.Gifts.length - 1].id,
              limit: 5
            },
            init: false }).then(() => this.load = false)
        }, 2000)
      }
    }
  },
  created () {
    this.Loading(true)
    this.GetGift({ params: { last: 0, limit: 15 }, init: true })
      .then(() => this.Loading(false))
  }
}
</script>

<style scoped>
.EnbGift {
  width: 100%;
  height: 96%;
}

.cont {
  width: 98%;
  height: 89%;
  padding: 1%;
  padding-top: 0;
  padding-bottom: 0;
  overflow: auto;
}

.cont-btn {
  padding-bottom: 1%;
  display: flex;
  justify-content: start;
  padding-left: 1%;
}

button {
  border: 0;
  font-size: 18px;
  padding: 1%;
  background-color: #000000;
  color: #FFFFFF;
  border-radius: 5px;
  cursor: pointer;
  margin-right: 1%;
}

.bottom {
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
}

@media (max-width: 500px) {
  .EnbGift {
    height: 70%;
  }
}
</style>
